import React from 'react';
import styles from './ProductChooser.module.sass';

import ProductCard from '../ProductCard/ProductCard';

class ProductChooser extends React.Component {
    render() {
        return (
            <div className={styles.Products}>
                {
                    this.props.products.map((prod) =>
                    <ProductCard
                        clicked={this.props.productClicked}
                        key={prod.id}
                        product={prod}
                        selected={prod.id === this.props.selectedProduct.id}
                        grayScale={prod.id !== this.props.selectedProduct.id && this.props.selectedProduct.id != null}
                    />)
                }
            </div>
        );
    }
}

export default ProductChooser;
